.entityContainer {
  padding-inline: var(--mantine-spacing-md);
  padding-block: var(--mantine-spacing-xs);
}

.identifiedEntityContainer {
  background-color: var(--mantine-color-gray-2);
}

.similarEntityContainer {
}

.highlightNumberCircle {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 900px;
  border: 2px solid var(--mantine-primary-color-7);
}
.highlightNumber {
  font-size: var(--mantine-font-size-sm);
  font-weight: 800;
  color: var(--mantine-primary-color-7);
}

/* Style for the container of the section */
.section-container {
  position: relative;
  width: 100%;
  height: 400px; /* Example height */
  background-color: lightblue;
  overflow: hidden;
}

/* Style for the content */
.content {
  position: relative;
  z-index: 1; /* Make sure the content is above the overlay */
  text-align: center;
  padding: 50px;
}

/* Style for the absolute overlay */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(25, 25, 25, 0.5); /* Initially semi-transparent */
  opacity: 0;
  transition: opacity 0.5s ease; /* Transition for the fade effect */
  z-index: 1; /* Below the content */
}

/* When the section is fading, change the opacity */
.fade {
  opacity: 1;
}
